import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import * as authActions from '../../actions/auth';
import User from '../../records/user';

export class Login extends React.Component {
  state = {
    errors: [],
    username: '',
    password: '',
  }

  clearErrors = () => {
    this.setState({ errors: [] });
  }

  onChange = e => {
    this.setState({ [e.target.name]: e.target.value });
  }

  login = e => {
    e.preventDefault();

    let errors = [];
    if (this.state.username === '') {
      errors.push('Username is required');
    }

    if (this.state.password === '') {
      errors.push('Password is required');
    }

    if (errors.length > 0) {
      this.setState({ errors: errors });
      return false;
    }

    this.props._auth.login(new User({
      username: this.state.username,
      password: this.state.password
    }))
    .catch(err => this.setState({ errors: ['There was a problem with your username or password.'] }));
  }

  render() {
    return <section className="section">
      <div className="container login">
        <div className="columns is-desktop">
          <div className="column"></div>
          <div className="column">
            <div className="has-text-centered" style={{ marginBottom: '20px' }}>
              <h5 className="title is-5">Sign in</h5>
            </div>
            {this.props.auth.get('reset') && <div className="notification is-warning">
              Password successfully reset, you may now login with your new password
            </div>}
            {this.state.errors.map((e, i) => <div key={i} className="notification is-danger">
              <button className="delete" onClick={this.clearErrors}></button>
              {e}
            </div>)}
            <div className="box">
              <form onSubmit={this.login}>
                <div className="field">
                  <label className="label" htmlFor="username">Username</label>
                  <div className="control">
                    <input
                      type="text"
                      className="input"
                      name="username"
                      onBlur={this.onChange}
                      onChange={this.onChange}
                      value={this.state.username} />
                  </div>
                </div>

                <div className="field">
                  <div className="is-pulled-right is-size-7 has-text-weight-semibold"><Link to="/forgot">Forgot password?</Link></div>
                  <label className="label" htmlFor="username">Password</label>
                  <div className="control">
                    <input
                      type="password"
                      className="input"
                      name="password"
                      onBlur={this.onChange}
                      onChange={this.onChange}
                      value={this.state.password} />
                  </div>
                </div>

                <button type="submit" className="button is-info is-fullwidth">Login</button>
              </form>
              
            </div>
          </div>
          <div className="column"></div>
        </div>
      </div>
    </section>;
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    _auth: bindActionCreators(authActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/components/user/Login.js